import React, { Component } from "react";
import { EditorLayout } from "../../contents";
import RaisedButton from "material-ui/RaisedButton";
import { Flex } from "rebass";

class FormDescription extends Component {
  constructor(props) {
    super(props);

    const { content } = props.record;
    let data = undefined;
    if (!Array.isArray(content)) {
      data = content;
    }
    this.state = {
      layoutSelected: props.record.content || [],
      content: data
    };
  }

  onChangeData = (data, dataRaw) => {
    this.props.updateContent(dataRaw);
    this.setState({ layoutSelected: dataRaw, content: data });
  };
  onResetPage = () => {
    this.setState({
      data: undefined,
      layoutSelected: []
    });
    this.editorpageDescription.onResetPage();
    this.props.updateContent(null);
  };

  render() {
    const { tabIndex } = this.props;
    return (
      <div>
        <Flex p={[2]} justify={["flex-end"]}>
          <RaisedButton
            label="Reset Description"
            primary={true}
            onClick={this.onResetPage.bind(this)}
          />
        </Flex>

        <EditorLayout
          ref={ref => (this.editorpageDescription = ref)}
          onChangeData={(data, dataRaw) => this.onChangeData(data, dataRaw)}
          data={this.state.content}
          isShow={tabIndex === 3}
        />
      </div>
    );
  }
}
//
export default FormDescription;



// WEBPACK FOOTER //
// ./src/products/form/FormDescriptions.js